export default {"src":"/_next/static/media/single-source-of-truth.34131754.svg","height":844,"width":844,"blurWidth":0,"blurHeight":0};